import React from 'react';
import { useMoney } from '../../hooks';
import { MoneyFragment as Fragment } from '../../graphql/graphql-constants';
/**
 * The `Money` component renders a string of the Storefront API's
 * [`MoneyV2` object](/api/storefront/reference/common-objects/moneyv2) according to the
 * locale in the `shopify.config.js` file. If `children` is a function, then it will
 * provide render props for the `children` corresponding to the object returned by the `useMoney` hook.
 */
export function Money(props) {
    const { money, children, as, ...passthroughProps } = props;
    const moneyObject = useMoney(money);
    const Wrapper = as !== null && as !== void 0 ? as : 'div';
    return (React.createElement(Wrapper, { ...passthroughProps }, typeof children === 'function'
        ? children(moneyObject)
        : moneyObject.localizedString));
}
Money.Fragment = Fragment;
export const MoneyFragment = Fragment;
